import util from '../common/util';
import { toggleDebugCache } from '@/common/debug';
import { aiPreviewUrl } from '@/clientEnv';

export default function() {
    util.setCookie('site-search-listings', true);

    // Search optimization
    toggleDebugCache();

    //  set time zone
    util.setCookie('timezone', util.getTimeZone());

    // ai preview
    if (util.inIframePreview && util.getQueryField('isMobile') && Object.values(aiPreviewUrl).includes(location.hostname)) {
        util.setCookie('is_mobile', util.getQueryField('isMobile'), 1);
    }

    // hide closely
    if (util.inIframePreview && util.getQueryField('hideClosely') === 'true' && Object.values(aiPreviewUrl).includes(location.hostname)) {
        util.setCookie('hide_closely', 'true', 1);
    }   
}
